import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CustomResultOfPaginatedListOfSmsSenderAgentDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SmsSenderAgentsService } from '../../../core/api/services';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { CreateSmsSenderAgentCommand } from './../../../core/api/models/create-sms-sender-agent-command';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { PaginatedListOfSmsSenderAgentDto } from './../../../core/api/models/paginated-list-of-sms-sender-agent-dto';
import { SmsSenderAgentDto } from './../../../core/api/models/sms-sender-agent-dto';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { SmsSenderAgentFormComponent } from "./sms-sender-agent-form/sms-sender-agent-form.component";

@Component({
    selector: 'app-sms-sender-agents',
    templateUrl: './sms-sender-agents.component.html',
    imports: [BaseIndexModule, SmsSenderAgentFormComponent]
})
export class SmsSenderAgentsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.smsSenderAgents;

  /* binding service endpoints */
  protected currentService = inject(SmsSenderAgentsService);
  paginationApiMethodName: string = this.currentService.smsSenderAgentsGetSmsSenderAgentsWithPagination.name;
  createGetApiMethodName: string = this.currentService.smsSenderAgentsCreateGet.name;
  deleteApiMethodName: string = this.currentService.smsSenderAgentsDelete.name;
  auditApiMethodName: string = this.currentService.smsSenderAgentsGetSmsSenderAgentAudits.name;
  /* binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfSmsSenderAgentDto>;
  items$: Observable<Array<SmsSenderAgentDto>>;
  formPageConfig: FormPageConfig<CreateSmsSenderAgentCommand> = {};
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        title: `${this.tableVocabs}smsSenderAgentReference`,
        name: 'smsSenderAgentReference',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },
      {
        title: `${this.tableVocabs}isSendActive`,
        name: 'isSendActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isSendBulkActive`,
        name: 'isSendBulkActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .smsSenderAgentsUpdateGet({ SmsSenderAgentId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
